import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home/home";
import Lead from "./pages/lead/lead";
import Locations from "./pages/locations/locations";
import Shirts from "./pages/shirts/shirts";
import "./site.scss";
import SiteToolbar from "./components/site-toolbar";
import SiteFooter from "./components/site-footer";
import { ConfigProvider } from "antd";
import LocationTest from "./pages/locastion-test/location-test";
import Privacy from "./pages/privacy/privacy";
import LeadGuide from "./pages/lead/guide";
import Contact from "./pages/contact/contact";
import Press from "./pages/press/press";

function PublicSite() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#ff0000",
          colorBgBase: "#fcfcfc",
          colorBgContainer: "#fffcfc",
          colorTextBase: "#111",
          borderRadius: 8,
        },
        // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
      }}
    >
      <div id="siteWrapper">
        <SiteToolbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/lead" element={<Lead />} />
            <Route path="/lead/guide" element={<LeadGuide />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/outfit" element={<Shirts />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/press" element={<Press />} />
          </Routes>
          <SiteFooter />
        </main>
      </div>
    </ConfigProvider>
  );
}

export default PublicSite;
